module.exports = __webpack_public_path__ + "img/IMG_9022_Mockup.cab3066c.jpg";